import React , {useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import Card from 'react-bootstrap/Card';
import Slider from "react-slick";
// import ProductCard from './../components/list/product-card';
import TestCardSlider from '../components/list/test-slider';
import {post_api_call, get_api_call, error_api_call} from '../actions/action-creators/common';
import {update_cart_count} from '../actions/action-creators/state-update';
//Error Handling
import {alertResponseMessage} from '../actions/action-creators/response';
import {SetMetaData} from './../helper/page-title';
import {stringToUrl} from './../helper/custom-function';
import bannerImg from '../assets/images/home-bg2.jpg';
import deliveryImg from '../assets/images/icon/home-delivery.png';
import safeImg from '../assets/images/icon/safe.png';
// import TestSingle from '../components/list/test-single';
const divScrollCount = window.innerWidth < 500
						? 3
						: (window.innerWidth > 499 && window.innerWidth < 769) 
							? 4
							: window.innerWidth > 768 && window.innerWidth < 991
							? 7
							: 8;
const itemScrollCount = window.innerWidth < 515
							? 2
							: (window.innerWidth > 514 && window.innerWidth < 769) 
								? 3
								: window.innerWidth > 768 && window.innerWidth < 991
								? 4
								: 6;
const settings = {
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: divScrollCount,
	slidesToScroll: divScrollCount
  };
//   const bannerSettings = {
// 	dots: true,
// 	infinite: true,
// 	// speed: 500,
// 	slidesToShow: 1,
// 	slidesToScroll: 1,
// 	autoplay: true,
// 	autoplaySpeed: 4000,
// 	arrows: false
//   };
  const productSettings = {
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: itemScrollCount,
	slidesToScroll: itemScrollCount,
  };
//   const settings = {
// 	dots: false,
// 	infinite: true,
// 	// speed: 500,
// 	slidesToShow: 4,
// 	slidesToScroll: 4,
// 	autoplay: true,
// 	autoplaySpeed: 4000 
// };
export default function Home(props){
	SetMetaData("Drug Store - A one-stop platform to Order Medicines & Book Lab Test", "", "");
	const deviceID = localStorage.getItem("device_id");
	const dispatch = useDispatch();
	// const windowPath = window.location.pathname.split('/')[1];
	const [sliderSetting, setSliderSetting] = useState({...settings});
	const [sliderItemSetting, setSliderItemSetting] = useState({...productSettings});
	// const [bannerData, setBannerData] = useState([]);
	const [categoryData, setCategoryData] = useState([]);
	const [organData, setOrganData] = useState([]);
	// Test
	const [testData, setTestData] = useState([]);
	const [itemLoaderTest, setItemLoaderTest] = useState({});
	const [cartDataTest, setCartDataTest] = useState({});
	// const [offerData, setOfferData] = useState([]);
	// const [latestData, setLatestData] = useState([]);
	// const [recommendedData, setRecommendedData] = useState([]);
	// const [trendingData, setTrendingData] = useState([]);
	// const [viewedData, setViewedData] = useState([]);
	//State Updation Data
	// const [latestActive, setLatestActive] = useState({});
	// const [recommendedActive, setRecommendedActive] = useState({});
	// const [trendingActive, setTrendingActive] = useState({});
	// const [viewedActive, setViewedActive] = useState({});
	// const [cartData, setCartData] = useState({});
	// const [itemLoader, setItemLoader] = useState({});
	//Get Data for Filter Options
	const fetchCatList = async() => {
        try{
			const catApiData = await get_api_call('main-category', {});
			if(catApiData.status === 200){
				setCategoryData(catApiData.data);
			}
        }catch(e){
			error_api_call({error: `home|fetchCatList|${e}`});
        }
    }
	//Get Data for Organs List
	const fetchOrganList = async() => {
        try{
			const organApiData = await get_api_call('lab-test-organ', {limit: 15, fetch_image: 1});
			if(organApiData.status === 200){
				setOrganData(organApiData.data);
			}
        }catch(e){
			error_api_call({error: `home|fetchOrganList|${e}`});
        }
    }
	//Get Test Data
	const fetchTestList = async() => {
        try{
			const testApiData = await post_api_call('lab-tests', {limit: 15, device_id: deviceID});
			console.log(testApiData, 'testApiDatatestApiDatatestApiData')
			if(testApiData.status === 200){
				var cartDetails = {};
				testApiData.data.forEach(pro_data => {
					cartDetails[pro_data.id] = pro_data.cart_quantity ? parseInt(pro_data.cart_quantity) : 0;
				});

				setCartDataTest({...cartDataTest, ...cartDetails});
				setTestData(testApiData.data);
			}
        }catch(e){
			error_api_call({error: `home|fetchTestList|${e}`});
        }
    }
	
    // const fetchAPIList = async() => {
    //     try{
	// 		const homeApiData = await post_api_call('home', {device_id: deviceID});
	// 		if(homeApiData.status === 200){
	// 			// setBannerData(homeApiData.data.banner);
	// 			setCategoryData(homeApiData.data.category);
	// 			// setOfferData(homeApiData.data.offer);
	// 			var cartDetails = {};
	// 			// var loaderData = {};
	// 			//Latest
	// 			var latestData = {};
	// 			homeApiData.data.latest_products.data.forEach(l_data => {
	// 				latestData[l_data.product_id] = {image: l_data.variation_data[0].thumbnail,
	// 												mrp: l_data.variation_data[0].mrp,
	// 												price: l_data.variation_data[0].price,
	// 												// cart_count: l_data.variation_data[0].added_quant,
	// 												variation_name: l_data.variation_data[0].variation_name,
	// 												product_variation_id: l_data.variation_data[0].product_variation_id
	// 											};
	// 				l_data.variation_data.forEach(r_cart => {
	// 					// console.log(r_cart)
	// 					cartDetails[r_cart.product_variation_id] = r_cart.added_quant;
	// 					// loaderData[r_cart.product_variation_id] = r_cart.added_quant;
	// 				});
	// 			});
	// 			//Recommended Data
	// 			var recommData = {};
	// 			homeApiData.data.recommended_products.data.forEach(r_data => {
	// 				recommData[r_data.product_id] = {image: r_data.variation_data[0].thumbnail,
	// 												mrp: r_data.variation_data[0].mrp,
	// 												price: r_data.variation_data[0].price,
	// 												// cart_count: r_data.variation_data[0].added_quant,
	// 												variation_name: r_data.variation_data[0].variation_name,
	// 												product_variation_id: r_data.variation_data[0].product_variation_id
	// 											};
	// 				r_data.variation_data.forEach(r_cart => {
	// 					// console.log(r_cart)
	// 					cartDetails[r_cart.product_variation_id] = r_cart.added_quant;
	// 					// loaderData[r_cart.product_variation_id] = r_cart.added_quant;
	// 				});
	// 			});
	// 			//Trending Data
	// 			var trendData = {};
	// 			homeApiData.data.trending_products.data.forEach(trend_data => {
	// 				trendData[trend_data.product_id] = {image: trend_data.variation_data[0].thumbnail,
	// 												mrp: trend_data.variation_data[0].mrp,
	// 												price: trend_data.variation_data[0].price,
	// 												// cart_count: trend_data.variation_data[0].added_quant,
	// 												variation_name: trend_data.variation_data[0].variation_name,
	// 												product_variation_id: trend_data.variation_data[0].product_variation_id
	// 											};
	// 				trend_data.variation_data.forEach(trend_cart => {
	// 					// console.log(trend_cart)
	// 					cartDetails[trend_cart.product_variation_id] = trend_cart.added_quant;
	// 					// loaderData[trend_cart.product_variation_id] = trend_cart.added_quant;
	// 				});
	// 			});
	// 			//Recently Viewed
	// 			var viewData = {};
	// 			homeApiData.data.viewed_products.data.forEach(view_data => {
	// 				viewData[view_data.product_id] = {image: view_data.variation_data[0].thumbnail,
	// 												mrp: view_data.variation_data[0].mrp,
	// 												price: view_data.variation_data[0].price,
	// 												// cart_count: view_data.variation_data[0].added_quant,
	// 												variation_name: view_data.variation_data[0].variation_name,
	// 												product_variation_id: view_data.variation_data[0].product_variation_id
	// 											};
	// 				view_data.variation_data.forEach(view_cart => {
	// 					// console.log(view_cart)
	// 					cartDetails[view_cart.product_variation_id] = view_cart.added_quant;
	// 					// loaderData[view_cart.product_variation_id] = view_cart.added_quant;
	// 				});
	// 			});
	// 			setLatestActive({...latestData});
	// 			setRecommendedActive({...recommData});
	// 			setTrendingActive({...trendData});
	// 			setViewedActive({...viewData});
	// 			setLatestData(homeApiData.data.latest_products.data);
	// 			setRecommendedData(homeApiData.data.recommended_products.data);
	// 			setTrendingData(homeApiData.data.trending_products.data);
	// 			setViewedData(homeApiData.data.viewed_products.data);
	// 			setCartData({...cartDetails});
	// 			// setItemLoader({...loaderData});
	// 		}
    //     }catch(e){
	// 		error_api_call({error: `home|fetchAPIList|${e}`});
    //     }
    // }
	useEffect(() => {
		//Initial API Data
		fetchCatList();
		fetchOrganList();
		fetchTestList();
		// fetchAPIList();
		const handleResize = () => {
			const setScrollCount = window.innerWidth < 500
									? 4
									: (window.innerWidth > 499 && window.innerWidth < 769) 
										? 5
										: window.innerWidth > 768 && window.innerWidth < 991
										? 7
										: 9;
			const setItemScrollCount = window.innerWidth < 515
									? 2
									: (window.innerWidth > 514 && window.innerWidth < 769) 
										? 3
										: window.innerWidth > 768 && window.innerWidth < 991
										? 4
										: 6;
			setSliderSetting({...sliderSetting, slidesToScroll: setScrollCount, slidesToShow: setScrollCount});
			setSliderItemSetting({...sliderItemSetting, slidesToScroll: setItemScrollCount, slidesToShow: setItemScrollCount})
		}
	
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, []);// eslint-disable-line react-hooks/exhaustive-deps
	//Change Select Options
	// const variationOnChange = (type, data) => {
	// 	try{
	// 		const activeData = {image: data.thumbnail,
	// 								mrp: data.mrp,
	// 								price: data.price,
	// 								// cart_count:data.added_quant,
	// 								variation_name: data.variation_name,
	// 								product_variation_id: data.product_variation_id
	// 							};
	// 		if(type === 'recommend'){
	// 			setRecommendedActive({...recommendedActive, [data.product_id]: {...activeData}});
	// 		}else if(type === 'trending'){
	// 			setTrendingActive({...trendingActive, [data.product_id]: {...activeData}});
	// 		}else if(type === 'viewed'){
	// 			setViewedActive({...viewedActive, [data.product_id]: {...activeData}});
	// 		}else if(type === 'latest'){
	// 			setLatestActive({...latestActive, [data.product_id]: {...activeData}});
	// 		}
	// 	}catch(e){
	// 		error_api_call({error: `home|variationOnChange|${e}`});
    //     }
	// }
	//Update Test Cart Quantity
	const addTestToCart = async(e, id, qty) => {
		e.preventDefault();
		try{
			console.log(id, qty)
			setItemLoaderTest({...itemLoaderTest, [id]: true});
			//Update Cart Item API Call
			const cartApiData = await post_api_call('update-cart-test', 
													{device_id: deviceID,
														// variation_detail_id,
														id,
														quantity: qty
													});
			if(cartApiData.status === 200){
				//Notify Msg
				const message = cartApiData.message; 
				if(cartApiData.success_status === 1
					|| cartApiData.success_status === 2
				){
					//Success
					alertResponseMessage({alert_type: 1, message});
				}else{
					//Error
					alertResponseMessage({alert_type: 2, message});
				}
				// setCartData({...cartData, [variation_detail_id]: qty});
				setCartDataTest({...cartDataTest, [id]: qty});
				// setCartData({...cartData, [id]: 1});
				if(cartApiData.data.cart_count !== ''){
					dispatch(update_cart_count({cart_count: cartApiData.data.cart_count}, cb_cart => {}));
				}
			}
			setItemLoaderTest({...itemLoaderTest, [id]: false});
		}catch(e){
			// console.log(e)
			// e.target.disabled = false;
            alertResponseMessage({alert_type: 2, message: "Error Updating Cart"});
			error_api_call({error: `home|addTestToCart|${e}`});
        }
	}
	//Update Item Cart Quantity
	// const addToCart = async(e, product_id, product_variation_id, qty) => {
	// 	try{
	// 		e.preventDefault();
	// 		e.target.disabled = true;
	// 		setItemLoader({...itemLoader, [product_variation_id]: true});
	// 		//Update Cart Item API Call
	// 		const cartApiData = await post_api_call('update-cart', 
	// 												{device_id: deviceID,
	// 												product_id,
	// 												product_variation_id,
	// 												quantity: qty});
	// 		if(cartApiData.status === 200){
	// 			//Notify Msg
	// 			const message = cartApiData.message; 
	// 			if(cartApiData.success_status === 1){
	// 				//Success
	// 				alertResponseMessage({alert_type: 1, message});
	// 			}else{
	// 				//Error
	// 				alertResponseMessage({alert_type: 2, message});
	// 			}
	// 			// setCartData({...cartData, [product_variation_id]: qty});
	// 			setCartData({...cartData, [product_variation_id]: cartApiData.data.quantity});
	// 			if(cartApiData.data.cart_count !== ''){
	// 				dispatch(update_cart_count({cart_count: cartApiData.data.cart_count}, cb_cart => {}));
	// 			}
	// 		}
	// 		setItemLoader({...itemLoader, [product_variation_id]: false});
	// 		e.target.disabled = false;
	// 	}catch(e){
	// 		// console.log(e)
	// 		e.target.disabled = false;
    //         alertResponseMessage({alert_type: 2, message: "Error Updating Cart"});
	// 		error_api_call({error: `home|addToCart|${e}`});
    //     }
	// }

    return (
		<>
			{/* Banner */}
			<section className="banner-main">
				{/* <div className="banner-home"></div> */}
				<div className="container">
					<div className="row">
						<div className="col-md-5 col-xl-5 order-0 order-md-1 text-center text-end-md img-wrapper">
							<img className="pt-7 pt-md-0 w-100" src={bannerImg} alt="Order Medicines"/>
						</div>
						<div className="col-md-7 col-xl-5 text-md-start offset-xl-1 text-center head-wrapper">
							<h1 className="fw-light">We're <strong>determined </strong>for<br/>your&nbsp;<strong>better life.</strong></h1>
							<p className="mb-3 mb-xl-5">Order Medicines & Book Lab Test now</p>
							<div className="d-none d-lg-block">
								<a className="btn btn-primary rounded-pill" href="/order-medicines" role="button">Order Medicines</a>
								<a className="btn btn-primary rounded-pill ms-5" href="/book-lab-test" role="button">Book Lab Test</a>
							</div>
							<div className="d-block d-lg-none">
								<a className="btn btn-primary rounded-pill btn-glow" href="/order-medicines" role="button">Order Medicines</a>
								<a className="btn btn-primary rounded-pill ms-5 btn-glow" href="/book-lab-test" role="button">Book Lab Test</a>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Order WhatsApp */}
			<section>
				<div className="container">
					<div className="row justify-content-around">
						<div className="col-md-12 col-xl-12 col-sm-12">
							<div className="card-content">
								<div className="card text-center p-3">
									<div>
										<h3>Order Medicines on WhatsApp <span className="mob-txt">{process.env.REACT_APP_WHATSAPP_NUM}</span></h3>
										<a className="btn btn-primary rounded-pill" href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUM}`} target="_blank" rel="noreferrer" role="button">Order Now</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <p className='text-center' style={{paddingTop: 30}}>
			<img alt="Coming Soon" src='data:image/png;base64,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' />
			</p> */}
			{/* Category List */}
			{/* {1 === 2 && ( */}
			<>
			{categoryData.length > 0 && (
				<section className="section-cat-wrapper card pro-hr">
					<div className="title">
						<h2>Medicines: Shop by Category</h2>
						<a href={`/order-medicines`}>VIEW ALL</a>
					</div>
					<div className="container">
						<div className="row">
							<div className="col-md-12 col-xl-12 col-sm-12">
								{/* <Card className="mb-3 mt-3"> */}
									<Card.Body>
										<Slider {...sliderSetting}>
											{categoryData.map((category, index) => (
												<a 
													key={`category${index}`}
													className="text-center"
													// href={`/order-medicines/${category.master_cat_id}/${stringToUrl(category.cat_name)}?type=main_category`}
													href={`/order-medicines?category=${category.master_cat_id}`}
													target="_self"
													title={category.cat_name}>
													<div className="category">
														<img src={category.icon} alt={category.cat_name} title={category.cat_name}/>
													</div>
													<div className="category-title"><p>{category.cat_name}</p></div>
												</a>
											))}
										</Slider>
									</Card.Body>
								{/* </Card> */}
							</div>
						</div>
					</div>
				</section>
			)}
			{/* Popular Lab Tests */}
			{testData.length > 0 && (
				<section className="section-cat-wrapper card pro-hr">
					<div className="title mb-3">
						<h2>Popular Lab Tests</h2>
						<a href={`/book-lab-test`}>VIEW ALL</a>
					</div>
					<div className="container">				
						<div className="row">
							<div className="col-md-12 col-xl-12 col-sm-12">
								<div className="row">
									{/* <SliderMaster sliderSettings={{...sliderItemSetting}}> */}
										<TestCardSlider
											slider={true}
											data={testData}
											addToCart={addTestToCart}
											// activeData={latestActive}
											cartData={cartDataTest}
											// variationOnChange={variationOnChange}
											itemLoader={itemLoaderTest}
											fetchKey={"latest"}
											sliderItemSetting={sliderItemSetting}
										/>
									{/* </SliderMaster> */}
								</div>
							</div>
						</div>
					</div>
				</section>
			)}
			{/* Lab Test by Organ */}
			{organData.length > 0 && (
				<section className="section-cat-wrapper card pro-hr">
					<div className="title">
						<h2>Find Tests by Organ</h2>
						<a href={`/book-lab-test`}>VIEW ALL</a>
					</div>
					<div className="container">
						<div className="row">
							<div className="col-md-12 col-xl-12 col-sm-12">
								{/* <Card className="mb-3 mt-3"> */}
									<Card.Body>
										<Slider {...sliderSetting}>
											{organData.map((organ, index) => (
												<a 
													key={`organ${index}`}
													className="text-center"
													// href={`/book-lab-test/organ/${stringToUrl(organ.name)}?organ=${organ.id}`}
													href={`/book-lab-test/organ?organ=${organ.id}`}
													target="_self"
													title={organ.name}>
													<div className="category">
														<img src={organ.icon} alt={organ.name} title={organ.name}/>
													</div>
													<div className="category-title"><p>{organ.name}</p></div>
												</a>
											))}
										</Slider>
									</Card.Body>
								{/* </Card> */}
							</div>
						</div>
					</div>
				</section>
			)}
			{/* Latest */}
			{/* {latestData.length > 0 && (
				<section className="section-cat-wrapper card pro-hr">
					<div className="col-md-12 col-xl-12 col-sm-12">
						<Card className="pro-hr mb-3 mt-3">
							<div className="title">
								<h2>Popular Lab Test</h2>
								<a href={`/book-lab-test`}>VIEW ALL</a>
							</div>
							<div className="row pe-3 ps-3">
								<div className="col-md-12 col-xl-12 col-sm-12">
									<div className="row">
										<ProductCard
											data={latestData}
											addToCart={addToCart}
											activeData={latestActive}
											cartData={cartData}
											variationOnChange={variationOnChange}
											itemLoader={itemLoader}
											fetchKey={"latest"}
											sliderItemSetting={sliderItemSetting}
										/>
									</div>
								</div>
							</div>
						</Card>
					</div>
				</section>
			)} */}
			<section className="section-lg-wrapper">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-md-3 col-xl-3 col-sm-12">
							<div className="feature-sec">
								<div className="pe-2">
									<img src={safeImg} alt="Safe & Secure"/>
								</div>
								<div>
									<h6>100% Genuine</h6>
									<p>We offer 100% Genuine medicines</p>
								</div>
							</div>
						</div>
						<div className="col-md-3 col-xl-3 col-sm-12">
							<div className="feature-sec">
								<div className="pe-2">
									<img src={deliveryImg} alt="Home Delivery"/>
								</div>
								<div>
									<h6>Home Delivery</h6>
									<p>We offer convenient home delivery of medicines</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Banner */}
			{/* {bannerData.length > 0 && (
				<div className="col-md-12 col-xl-12 col-sm-12">
					<div className="mb-5 mt-3 banner-section" style={{position: "relative"}}>
						<Slider {...bannerSettings}>
							{bannerData.map((banner, index) => (
								<a key={`banner${index}`} className="text-center banner-wrapper" href={`/${banner.url}`} target="_self" title={banner.title}>
									<div className="banner">
										<img src={banner.banner} alt={banner.title} title={banner.title} />
									</div>
								</a>
							))}
						</Slider>
					</div>
				</div>
			)} */}
			{/* Based on Your Interest */}
			{/* {recommendedData.length > 5 && (
				<div className="col-md-12 col-xl-12 col-sm-12">
					<Card className="pro-hr mb-3 mt-3">
						<div className="title">
							<h2>Suggested for You</h2>
							<a href={`/pooja-samagri/recommended/suggested-for-you?type=suggested_for_you`}>VIEW ALL</a>
						</div>
						<div className="row pe-3 ps-3">
							<div className="col-md-12 col-xl-12 col-sm-12">
								<div className="row">
									<ProductCard
										data={recommendedData}
										addToCart={addToCart}
										activeData={recommendedActive}
										cartData={cartData}
										variationOnChange={variationOnChange}
										itemLoader={itemLoader}
										fetchKey={"recommend"}
										sliderItemSetting={sliderItemSetting}
									/>
								</div>
							</div>
						</div>
					</Card>
				</div>
			)} */}
			{/* Offer */}
			{/* {offerData.length > 0 && (
				<div className="col-md-12 col-xl-12 col-sm-12">
					<div className="row mb-3 mt-3 justify-content-center">
						{offerData.map((offer, index) => (
							<div key={`offer${index}`} className="col-md-4 col-12 col-sm-12">
								<Card className="offer-wrap mb-2 mb-sm-0">
									<div className="star-eight">
										<div className="content">
											{offer.type === 'rupee' 
												? `₹​${parseInt(offer.discount_value).toFixed()} Off`  
												: (offer.type === 'percentage'
													? `${parseInt(offer.discount_value).toFixed()}% Off`
													: 'Free Delivery')
											}
										</div>
									</div>
									<p className="offer-desc">{offer.description}</p>
									<div className="promo-wrap">Use Code: <span className="promo">{offer.coupon_code}</span></div>
								</Card>
							</div>
						))}
					</div>
				</div>
			)} */}
			{/* Trending */}
			{/* {trendingData.length > 0 && (
				<div className="col-md-12 col-xl-12 col-sm-12">
					<Card className="pro-hr mb-3 mt-3">
						<div className="title">
							<h2>Trending</h2>
							<a href={`/pooja-samagri/trending/trending?type=trending`}>VIEW ALL</a>
						</div>
						<div className="row pe-3 ps-3">
							<div className="col-md-12 col-xl-12 col-sm-12">
								<div className="row">
									<ProductCard
										data={trendingData}
										addToCart={addToCart}
										activeData={trendingActive}
										cartData={cartData}
										variationOnChange={variationOnChange}
										itemLoader={itemLoader}
										fetchKey={"trending"}
										sliderItemSetting={sliderItemSetting}
									/>
								</div>
							</div>
						</div>
					</Card>
				</div>
			)} */}
			{/* Recently Viewed */}
			{/* {viewedData.length > 0 && (
				<div className="col-md-12 col-xl-12 col-sm-12">
					<Card className="pro-hr mb-3 mt-3">
						<div className="title">
							<h2>Recently Viewed</h2>
							<a href={`/pooja-samagri/viewed/recently-viewed?type=viewed`}>VIEW ALL</a>
						</div>
						<div className="row pe-3 ps-3">
							<div className="col-md-12 col-xl-12 col-sm-12">
								<div className="row">
									<ProductCard
										data={viewedData}
										addToCart={addToCart}
										activeData={viewedActive}
										cartData={cartData}
										variationOnChange={variationOnChange}
										itemLoader={itemLoader}
										fetchKey={"viewed"}
										sliderItemSetting={sliderItemSetting}
									/>
								</div>
							</div>
						</div>
					</Card>
				</div>
			)} */}
			</>
			{/* )} */}
        </>
    )
}
